export default "/_next/static/images/a758eaff3138c4f26663a35a35a659b8.png";